'use client'

import Link from 'next/link'
import Card from '@/components/ui/Card'
import ImageWithPlaceholder from '@/components/ui/ImageWithPlaceholder'
import Button from '@/components/ui/Button'
import { useProductSelection } from '@/contexts/ProductSelectionContext'
import { FaPlus, FaMinus } from 'react-icons/fa'

interface Product {
  id: string
  name: string
  slug: string
  description: string | null
  main_image_path: string | null
  category_id: string | null
  brand_id: string | null
}

interface ProductCardProps {
  product: Product
  categorySlug: string
  brandName?: string | null
  showInterestedButton?: boolean
}

export default function ProductCard({ 
  product, 
  categorySlug, 
  brandName,
  showInterestedButton = true 
}: ProductCardProps) {
  const { addProduct, removeProduct, isSelected } = useProductSelection()
  const selected = isSelected(product.id)

  const handleToggleInterest = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    
    if (selected) {
      removeProduct(product.id)
    } else {
      addProduct({
        id: product.id,
        name: product.name,
        slug: product.slug,
        category_id: product.category_id,
      })
    }
  }

  return (
    <Card hover className="h-full animate-scale-in group relative">
      <Link href={`/urunler/${categorySlug}/${product.slug}`}>
        <div className="mb-4 relative w-full aspect-video rounded-2xl overflow-hidden bg-gray-100">
          <ImageWithPlaceholder
            src={product.main_image_path}
            alt={product.name}
            fill
            className="object-cover"
          />
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          {product.name}
        </h2>
        {brandName && (
          <p className="text-xs text-primary-600 mb-2">
            {brandName}
          </p>
        )}
        {product.description && (
          <p className="text-sm text-gray-600 line-clamp-3 mb-4">
            {product.description}
          </p>
        )}
      </Link>
      
      {showInterestedButton && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <Button
            onClick={handleToggleInterest}
            variant={selected ? 'outline' : 'default'}
            className={`w-full flex items-center justify-center gap-2 ${
              selected 
                ? 'bg-primary-50 border-primary-300 text-primary-700 hover:bg-primary-100' 
                : ''
            }`}
          >
            {selected ? (
              <>
                <FaMinus />
                Kaldır
              </>
            ) : (
              <>
                <FaPlus />
                Ekle
              </>
            )}
          </Button>
        </div>
      )}
    </Card>
  )
}

